import { SidePanelSide } from 'designSystem/components/sidePanelContext'

export function panelTrackWidthForPointer({
  clientX,
  container,
  side,
}: {
  clientX: number
  container: { left: number; right: number }
  side: SidePanelSide
}): number {
  return side === SidePanelSide.Right
    ? container.right - clientX
    : clientX - container.left
}
